// src/components/EmailLinkRequest.jsx
import React from 'react';
import { useForm } from 'react-hook-form';
import { getAuth, sendSignInLinkToEmail } from 'firebase/auth';
import { toast, Bounce } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export default function EmailLinkRequest() {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();
  const { t } = useTranslation();

  const actionCodeSettings = {
    // Redirect back to this URL after the user clicks the link
    url: window.location.origin + '/email-callback',
    handleCodeInApp: true,
  };

  const onSubmit = async ({ email }) => {
    const auth = getAuth();
    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      // Save email so we can retrieve it in the callback
      window.localStorage.setItem('emailForSignIn', email);
      toast.success(t('Email Link Sent', { email }), { transition: Bounce });
    } catch (err) {
      console.error(err);
      toast.error(err.message || t('email Error'), { transition: Bounce });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <input
        type="email"
        placeholder={t('email')}
        {...register('email', { required: t('emailreq') })}
        className="w-full p-3 rounded-full border focus:ring-2 focus:ring-[#47b5ff]"
      />
      {errors.email && <p className="text-xs text-red-500">{errors.email.message}</p>}
      <button
        type="submit"
        disabled={isSubmitting}
        className="w-full bg-[#ff8000] text-white py-3 rounded-full disabled:opacity-50"
      >
        {isSubmitting ? t('sending') : t('Send SignIn Link')}
      </button>
    </form>
  );
}
